import React, { Component } from "react";
import { Slide } from "react-slideshow-image";

import slideShow1 from "../images/slideShow/slideShow1.jpg";
import slideShow2 from "../images/slideShow/slideShow2.jpg";
import slideShow3 from "../images/slideShow/slideShow3.jpg";
import slideShow4 from "../images/slideShow/slideShow4.jpg";
import heroOsteo from "../images/hero-osteo.jpg";

import Grid from "material-ui/Grid";
import Typography from "material-ui/Typography";
import Hidden from "material-ui/Hidden";

const images = [slideShow1, slideShow2, slideShow3, slideShow4];

class Home extends Component {
  constructor() {
    super();

    this.state = {
      images,
      selectedImageIndex: 0,
    };
  }

  render() {
    return (
      <div>
        <Slide images={images} duration={3000} transitionDuration={1000} />
        <div className="landingTextContainer">
          <Grid container spacing={8} justify="center">
            <Grid item xs={10} sm={8} md={6}>
              <Hidden mdDown>
                <Typography
                  component="h3"
                  align="center"
                  variant="display3"
                  className="landingHeading"
                >
                  O poliklinici
                </Typography>
              </Hidden>
              <Hidden only={["xs", "lg", "xl"]}>
                <Typography
                  component="h3"
                  align="center"
                  variant="display2"
                  className="landingHeading"
                >
                  O poliklinici
                </Typography>
              </Hidden>
              <Hidden smUp>
                <Typography
                  component="h3"
                  align="center"
                  variant="display1"
                  className="landingHeading"
                >
                  O poliklinici
                </Typography>
              </Hidden>
              <Typography
                component="p"
                variant="body2"
                align="center"
                className="landingTextContainer"
              >
                Poliklinka Sente je osnovana 01.06.2004.
              </Typography>
              <Typography
                component="p"
                variant="body2"
                align="justify"
                className="landingTextContainer"
              >
                Nalazi se u savremeno opremljenom prostoru u centru Subotice.
                Delatnost poliklinike je dijagnostika i lečenje bolesti iz
                oblasti dermatologije, otorinolarngologije, ginekologije,
                interne medicine sa supspecijalistima iz: gastroenterologije,
                kardiologije, endokrinologije, nefrologije, hematologije,
                reumatologije, onkologije; pulmologije neurologije i
                psihijatrije, pedijatrije (sa supspecijalistom iz dečije
                pulmologije, neurologije i alergologije), urologije, ortopedije,
                hirurgije, ultrazvučne dijagnostike i opšte medicine.
              </Typography>
              <Typography
                component="p"
                variant="body2"
                align="justify"
                className="landingTextContainer"
              >
                Poliklinika Sente raspolaže savremenom opremom od kojih
                izdvajamo: kompjuterizovani dermoskop (aparat za
                kompjuterizovani pregled mladea), ugljendioksidni laser za
                uklanjanje kožnih promena, terapijski laser, radiotalani nož,
                osteodenzimetar (DEXA), aparate za ispitivanje sluha i ravnoteže
                kod odraslih i dece (audiometar, timpanometar, otoakustičke
                emisije, videonistagmografiju, ispitivanje evociranih
                potencijala - BERA), EKG holter za 24-časovno snimanje srca i
                krvnog pritiska, koplopskop, utrazvučne aparate za pregled
                unutrašnjih organa trbuha (jetra, žučna kesica, pankreas,
                bubnrezi, prostata), vrata i štitaste žlezde, dojke, testisa,
                ginekološka sonda sa 4 D sondom za ekspertski ultrazvuk
                trudnoće, kao i kolor dopler za dijagnostiku krvnih sudova vrata
                i glave, gastroskop, kolonoskop, videoendoskop za pegled nosa i
                nosnog ždrela, elektroencefalograf (EEG), aparat za
                elektroforezu lekova, aparat za lečenje pojačanog znojenja kože
                dlanova i tabana, inhalator, CTG, i druge aparate za
                dijagnostiku.
              </Typography>
              <Typography
                component="p"
                variant="body2"
                align="justify"
                className="landingTextContainer"
              >
                U saradnji sa laboratorijom Medlab vršimo i uzimanje uzoraka
                krvi za sve analize koje su potrebne radi utvrđivanja vašeg
                zdravstvenog stanja, kao i briseve grla, uha, nosa, vaginalnog
                sekreta i citološkog pregleda (PAPA test).
              </Typography>
              <Typography
                component="p"
                variant="body2"
                align="justify"
                className="landingTextContainer"
                style={{ marginTop: "16px" }}
              >
                Mi smo poliklnika za Vas i vašu porodicu. Zahvaljujemo vam što
                ste posetili naš sajt, kao i na ukazanom poverenju.
              </Typography>
              <hr />
              <br />
              <br />
              <Typography
                component="h6"
                align="center"
                variant="display1"
                className="landingHeading"
              >
                Vaskularna hirurgija
              </Typography>
              <Typography
                component="h6"
                variant="display1"
                style={{ fontSize: "20px", marginBottom: "16px" }}
              >
                1. Lečenje bolesti abdominalne aorte - zamena obolelog dela
                trbušne aorte ili kreiranje bajpasa sa trbušne aorte na arterije
                donjih ekstremiteta
              </Typography>{" "}
              <Typography
                component="h6"
                variant="display1"
                style={{ fontSize: "20px", marginBottom: "16px" }}
              >
                2. Lečenje bolesti karotidnih aterija i hirurška prevencija
                moždanog udara
              </Typography>{" "}
              <Typography
                component="h6"
                variant="display1"
                style={{ fontSize: "20px", marginBottom: "16px" }}
              >
                3. Lečenje bolesti arterija gornjih i donjih ekstremiteta
              </Typography>{" "}
              <Typography
                component="h6"
                variant="display1"
                style={{ fontSize: "20px", marginBottom: "16px" }}
              >
                4. Kreiranje svih vrsta vaskularnih pristupa za hemodijalizu
              </Typography>{" "}
              <Typography
                component="h6"
                variant="display1"
                style={{ fontSize: "20px", marginBottom: "16px" }}
              >
                5. Lečenje svih urgentnih stanja iz oblasti vaskularne hirurgije
              </Typography>
              <br />
              <br />
              <hr />
              <br />
              <Typography
                component="h6"
                align="center"
                variant="display1"
                style={{ fontSize: "24px", marginBottom: "16px" }}
              >
                Novi osteodenzitometar u Subotici!
              </Typography>
              <Typography
                component="h6"
                align="center"
                variant="display1"
                className="landingHeading"
              >
                Pregled kompletnog koštanog sistema u roku od 5 minuta!
              </Typography>
              <Typography
                component="p"
                variant="body2"
                align="justify"
                className="landingTextContainer"
              >
                U Poliklinici Sente od danas možete sebi priuštiti pregled
                kompletnog koštanog sistema, uz informaciju o procentu rizika od
                osteoporoze. Pacijenti sa implantom bez problema mogu izvršiti
                pregled sa informacijama za lekara specijalistu o stepenu
                uspešnosti izvedene operacije. Uz jedinstveni prikaz rezultata u
                3D moguće je imati kompletniju sliku problema i rešenja. Pored
                celokupnog, moguće izvršiti snimanje regija od interesa kao što
                su koleno, kuk, rame, lakat, skočni zglob, kičma,...
              </Typography>
              <img
                src={heroOsteo}
                style={{
                  maxWidth: "600px",
                  height: "auto",
                  margin: "auto",
                  display: "block",
                }}
                alt="Osteodenzimetrija"
              />
              <Typography
                component="p"
                variant="body2"
                align="justify"
                className="landingTextContainer"
              >
                Preveniranje osteoporoze kao bolesti čovečanstva 21.veka je sada
                dostupno svima. Informacija o riziku od preloma može biti
                prelomni trenutak u vašoj pažnji i brizi o sebi.
              </Typography>
              <Typography
                component="p"
                variant="body2"
                align="justify"
                className="landingTextContainer"
              >
                Pored ljudi sa problemima koštanog sistema na našoj DEXI možete
                izvršiti snimanje kompletnog tela sa indeksima telesne težine,
                mišićne mase, debljine što je za sve sportiste prilika kako da
                prate svoje napredovanje kao i odstupanja, tako i da ciljano
                naprave strategiju za određeni deo tela. Uz pomoć nutricioniste,
                a uz rezultate sa DEXE vaš lični rezultat mora biti na
                maksimumu!
              </Typography>
              <Typography
                component="p"
                variant="body2"
                align="justify"
                className="landingTextContainer"
              >
                Pored odraslih, preglede mogu imati i pedijatrijski pacijenti
                koji uz specijalna softverska rešenja na našem aparatu imaju
                detaljniji izveštaj svog kliničkog stanja, može se pratiti
                razvojno doba deteta kao i odstupanja od očekivanih referentnih
                vrednosti.
              </Typography>
            </Grid>
          </Grid>
        </div>
      </div>
    );
  }
}

export default Home;



// WEBPACK FOOTER //
// ./src/components/Home.js